// extracted by mini-css-extract-plugin
export default {"content_container":"ChangeEmailTemplatePopup_content_container__mp51E","btn_no":"ChangeEmailTemplatePopup_btn_no__9wWjO"};